import type { EventStatus } from './home.types.ts';

export const eventStatusStyles = {
  CONFIRMED: 'bg-green-100 text-green-700',
  COMPLETE: 'bg-yellow-100 text-yellow-700',
  IN_PROGRESS: 'bg-yellow-100 text-yellow-700',
  HOLD: 'bg-yellow-100 text-yellow-700',
  PENDING: 'bg-yellow-100 text-yellow-700',
  CANCELLED: 'bg-ande-gray-100 text-ande-gray-500',
  NO_SHOW: 'bg-ande-gray-100 text-ande-gray-500',
  WITHDRAWN: 'bg-ande-gray-100 text-ande-gray-500',
  LOST: 'bg-ande-gray-100 text-ande-gray-500',
} satisfies Record<EventStatus, string>;

export const formatEventStatusLabel = (status: EventStatus): string =>
  status.toLowerCase().replace('_', ' ');
